var getInstantiatorFunction = require('./getInstantiatorFunction')

module.exports = function(fn, args){
	return getInstantiatorFunction(args.length)(fn, args)
}


//////////////////
// WEBPACK FOOTER
// ../~/newify/index.js
// module id = 2645
// module chunks = 2